// extracted by mini-css-extract-plugin
export default {"Vimeo":"PwzAoH6x687hWwAqEEX2"};